module.exports = __webpack_public_path__ + "static/media/Fleur Delacour 2.2c978f0a.jpg";